import React from 'react';
import { getYouTubeEmbedUrl } from '../../../../utils/promotionUtils/getYouTubeVideoId';
import classes from '../ContentPromotionPopup.module.css';

const YoutubeContent = ({ url, title }) => {
    
    const embedUrl = getYouTubeEmbedUrl(url);

    return embedUrl &&
        <iframe
            className={classes.Renderer}
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            title={title}
        />;
};

export default YoutubeContent;
